<template>
  <van-popup
    v-model="visible"
    position="bottom"
    round
    closeable
    close-icon="close"
    style="min-height: 40%;"
  >
    <div class="exc">
      <div class="exc_title mb_34 fs_20 bold text_center">自选代金券</div>
      <div class="exc_main mb_24">
        <div class="exc_main_title pl_8">兑换代金券面额</div>
        <div class="exc_input">
          <van-field
            v-model="num"
            label-class="wx-field__label"
            label-width="16px"
            type="digit"
            label="￥"
            :error="num > 1000"
          />
        </div>
        <div class="exc_main_tip pl_8">消耗返利点{{ consumer }}</div>
      </div>
      <div class="exc_tips mb_12">
        <p class="fs_15 mb_6">温馨提示: </p>
        <p class="fs_12 mb_4">1. 剩余可自选代金券次数{{ exchangeTimes }}次</p>
        <p class="fs_12">2. 代金券将于 24h 内到账, 后续可至【我的】-【代金券】查看</p>
      </div>
      <div class="exc_btn">
        <van-button round size="large" color="#FFB83C" :loading="loading" @click="onSure">
          <span class="fs_18">确认兑换</span>
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Button, Field } from 'vant';
export default {
  props: {
    exchangeTimes: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rate: {
      type: Number,
      default: 1,
    },
  },
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Field.name]: Field,
  },
  data () {
    return {
      visible: false,
      num: '',
    }
  },
  watch: {
    visible (f) {
      !f && this.$emit('close')
    },
  },
  computed: {
    consumer () {
      if (Number.isNaN(this.num)) return 0
      const res = this.num / this.rate
      if (Number.isNaN(res)) return 0
      return res.toFixed(2)
    },
  },
  methods: {
    triggerVisible (visible) {
      this.visible = visible;
    },
    onSure () {
      if (this.num <= 0 || this.num === '' || Number.isNaN(this.num)) {
        this.$toast('请输入正确的兑换面额')
        return
      }
      if (this.num > 1000) {
        this.$toast('最高兑换1000面额')
        return
      }
      this.$emit('sure', this.num)
    },
    clear () {
      this.num = undefined
    },
  },
}
</script>

<style lang="scss" scoped>
.exc {
  color: #454545;
  padding: 24px;
  .exc_input {
    border-bottom: 1px solid #cecece;
    margin-bottom: 6px;
  }
  ::v-deep .van-cell {
    padding: 4px 6px;
    align-items: end;
    background-color: transparent;
  }
  ::v-deep .wx-field__label {
    font-size: 22px;
    margin-bottom: 4px;
    color: #000;
  }
  ::v-deep .van-field__value {
    font-size: 36px;
    line-height: 36px !important;
  }
}
.exc_main {
  padding: 12px 8px 8px;
  background-color: #f4f4f4;
  border-radius: 18px;
  box-shadow: 0px 0px 2.5px 0px rgba(74,74,74,0.68); 
}
.exc_btn {
  width: 224px;
  margin: 0 auto;
}
</style>
